@if (title) {
  <h3 class="h3 gauge-title">{{ title }}</h3>
}
<div class="text-center" style="max-height: 14rem; overflow: hidden">
  @if (gaugeOptions) {
    <highcharts-chart
      [Highcharts]="Highcharts"
      [options]="gaugeOptions"
      [ngStyle]="{ height: height, width: width, display: 'block' }"
    ></highcharts-chart>
  }
</div>
